import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Table,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import { CheckBox } from "@mui/icons-material";

type Props = {};

const selectOption = [
  { value: 1, label: "Antenna-1" },
  { value: 2, label: "Antenna-2" },
  { value: 3, label: "Antenna-3" },
  { value: 4, label: "Antenna-4" },
  { value: 5, label: "Antenna-8" },
];

interface memberOption {
  empName: string;
  empCode: string;
  empMobileNo: string;
  empPanNumber: string;
  email: string;
  empDob: string;
  departmentName: string;
  designationName: string;
  value: string;
}

interface FileOption {
  value: number;
  fileName: string;
  fileNo?: string;
  synopsis: string;
  remark: string;
  totalPages: string;
  rfid: string;
  chackNo: string;
}

const IssueReturn = (props: Props) => {
  //Member Detail Section
  const [memberName, setMemberName] = useState("");
  const [memberGroup, setMemberGroup] = useState("");
  const [department, setDepartment] = useState("");
  const [issuesLimit, setIssuesLimit] = useState("");
  const [courseDesignation, setCourseDesignation] = useState("");
  const [alreadyIssued, setAlreadyIssued] = useState("");
  const [issueDays, setIssueDays] = useState("");
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  const [memberOption, setMemberOption] = useState<memberOption[] | any>([]);
  const [antina, setAntina] = useState<any>(0);

  const [epcNumber, setEPCNumber] = useState<any>("");
  const [fileDetails, setFileDetails] = useState<FileOption[] | any>([]);
  const [fileDetailsTableData, setFileDetailsTableData] = useState<any>([]);

  //FileDetails Tran section
  const [chakno, setChakNo] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileNo, setFileNo] = useState("");
  const [remark, setRemark] = useState("");
  const [rfid, setRFID] = useState("");
  const [synopsis, setSynopsis] = useState("");
  const [totalPages, setTotalPages] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const [LocationOption, setLocationOption] = useState<any>([
    { value: "-1", label: "Select To Location" },
  ]);

  const [receiverName, setReceiverName] = useState("");
  const [senderName, setSenderName] = useState("");
  const [selectedLocationLabel, setSelectedLocationLabel] = useState('');
  const [fileIDs, setFileID] = useState("");

  const [isDefaultValueSet, setIsDefaultValueSet] = useState(false);

  if (!isDefaultValueSet) {
    const defaultLocation = LocationOption.find(
      (option: any) => option.value === parseInt(synopsis)
    );

    if (defaultLocation) {
      setSelectedLocationLabel(defaultLocation.label);
      setIsDefaultValueSet(true);
    }
  }

  
  // console.log("label check", selectedLocationLabel)
  const handleChange = () => {
    setIsChecked(!isChecked);
    console.log(isChecked)
  };

  useEffect(() => {
    fetchMemberData();
    getFileDtailsData();
    getLocation();
  }, []);

  const getLocation = () => {
    const collectData = {
      id: -1,
    };
    api
      .post(`LocationItems/GetMappedLocation`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.location,
          value: item.id,
        }));
        setLocationOption(arr);
      });
  };


  const getAntennaScan = async () => {
    // console.log("chck");
    if (!antina) {
      toast.error("Please Select Any one Antenna");
      return true;
    }

    const collectData = {
      id: -1,
      epc: "",
      // antnum: antina,
      antnum: parseInt(antina.toString()),
      type: "Issue",
    };
    const response = await api.post(`AssigningRfid/GetRfid`,
      collectData
    );
    console.log("check result", response.data.data);

    const epcValues = response.data.data.map((item: any) => item.fileName);
    var arr = [];
    for (let i = 0; i < response.data.data.length; i++) {
      arr.push({
        fileNo: response.data.data[i]["fileNo"],
        fileName: response.data.data[i]["fileName"],
        synopsis: response.data.data[i]["synopsis"],
        remark: response.data.data[i]["remark"],
        rfid: response.data.data[i]["rfid"],
        chakno: response.data.data[i]["chackNo"],
      });
    }
    setEPCNumber(epcValues.join(", "));
    setFileDetailsTableData(arr);
  };

  const getFileDtailsData = async () => {
    const collectData = {
      fileID: -1,
      fileType: -1,
      fileGroup: -1,
      fileCategory: -1,
      fileClass: -1,
      fileSubject: -1,
      show: true,
      exportOption: "",
    };
    const response = await api.post(`FileDetail/GetFileDetails`,
      collectData
    );
    const arr: FileOption[] = response.data.data.map((item: any) => ({
      value: item.fileID,
      fileName: item.fileName,
      fileNo: item.fileNo,
      currentLocation: item.currentLocation,
      remark: item.remark,
      totalPages: item.totalPages,
      rfid: item.rfid,
      chackNo: item.chackNo,
    }));

    // const filteredArr = arr.filter((item: any) => item.fileNo);

    setFileDetails(arr);
  };

  const fetchMemberData = () => {
    const collectData = {
      empid: -1,
      userId: "-1",
      empName: "",
      empMobileNo: "",
      empPincode: 0,
      roleId: "-1",
      empDesignationId: -1,
      empDeptId: -1,
      empStateId: -1,
      empCountryID: -1,
      empCityId: -1,
    };
    api
      .post(`EmpMaster/GetEmpmaster`, collectData)
      .then((response) => {
        const arr: memberOption[] = response.data.data.map((items: any) => ({
          empName: items.empName,
          empCode: items.empCode,
          empMobileNo: items.empMobileNo,
          empPanNumber: items.empPanNumber,
          email: items.email,
          empDob: items.empDob,
          departmentName: items.departmentName,
          designationName: items.designationName,
          value: items.empid,
        }));
        setMemberOption(arr);
      });
  };

  const addRow = () => {
    // if ( !fileNo || !chakno || !rfid ) {
    //   // If any of the required fields are empty, show an alert message
    //   alert("Please fill in all required fields before adding a new row.");
    //   return;
    // }

    const existingRow = fileDetailsTableData.find((row: any) => row.fileName === fileName && row.fileNo === fileNo && row.chakno === chakno && row.rfid === rfid);

    if (existingRow) {
      // If the entry already exists, show an alert message
      alert("This entry already exists.");
      return;
    }

    const newRow = {
      id: fileDetailsTableData.length + 1,
      fileName: fileName,
      fileNo: fileNo,
      chakno: chakno,
      rfid: rfid,
      synopsis: selectedLocationLabel,
      totalPages: totalPages,
      remark: remark,
    };
    setFileDetailsTableData((prevTableData: any) => {
      const updatedTableData = [...prevTableData, newRow];
      console.log(newRow);
      return updatedTableData;
    });

    // setFileDetails("");
    setChakNo("");
    setFileName("");
    // setFileNo("");
    setRemark("");
    setRFID("");
    setSynopsis("");
    // setTotalPages("");
  };

  const handleSubmit= async()=>{
    const collectData={
      "hid": -1,
      "fileID": fileIDs,
      "fileNumber": fileNo,
      "fileDate": "2024-04-29T08:23:40.077Z",
      "fromLocation": selectedLocationLabel,
      "toLocation": "",
      "sender": senderName,
      "receiver": receiverName,
      "createdDate": "2024-04-29T08:23:40.077Z",
      "createdBy": ""
    }
    console.log("check value", collectData)
    //FileMovementHistory/AddUpdateFileMovementHistory
    const response = await api.post(`FileMovementHistory/AddUpdateFileMovementHistory`,
      collectData
    );

    if (response.data.isSuccess) {
      toast.success(response.data.mesg);
      // navigate("/Library/FileDetail");
    } else {
      // setToaster(true);
      toast.error(response.data.mesg);
    }

  }

  return (
    <div
      style={{
        padding: "-5px 5px",
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        marginTop: "3vh",
        // border: ".5px solid #FF7722",
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          textAlign="center"
          style={{ fontSize: "18px", fontWeight: 500 }}
        >
          Issue Return
        </Typography>

        <Divider />
        <br />

        <form>
          <Grid item xs={12} sm={12} container spacing={2}>
            <Grid item xs={12} container spacing={2}>


              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  options={selectOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue);
                    setAntina(newValue?.value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<span>Select Antenna</span>}
                    />
                  )}
                />
              </Grid>

              {/* scan */}

              <Grid sm={3} item>
                <Button
                  variant="contained"
                  style={{
                    marginBottom: 15,
                    backgroundColor: "secondary",
                  }}
                  onClick={getAntennaScan}
                >
                  scan
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} container spacing={4}>
              {/* Member */}
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={memberOption}
                  getOptionLabel={(option: any) => option.empName}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (newValue) {
                      console.log("Selected value:", newValue?.value);
                      // if (newValue?.empCode && newValue?.empName) {
                      //   const newName = `${newValue?.empCode} - ${newValue?.empName}`;
                      // }
                      setSenderName(newValue?.value);

                    } else {
                      setSenderName("");

                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Sender Member" />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={memberOption}
                  getOptionLabel={(option: any) => option.empName}
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);
                    if (newValue) {
                      console.log("Selected value:", newValue);
                      setReceiverName(newValue?.value);
                      if (newValue?.empCode && newValue?.empName) {
                        const newName = `${newValue?.empCode} - ${newValue?.empName}`;
                        setMemberName(newName);
                      }
                      setDepartment(newValue?.departmentName);
                      setMemberGroup(newValue?.empMobileNo);
                      setIssuesLimit(newValue?.empPanNumber);
                      setCourseDesignation(
                        dayjs(newValue?.empDob).format("DD-MM-YYYY")
                      );
                      setAlreadyIssued(newValue?.email);
                      setIssueDays(newValue?.designationName);
                      setAccordionExpanded(true);
                    } else {
                      setMemberName("");
                      setDepartment("");
                      setMemberGroup("");
                      setIssuesLimit("");
                      setCourseDesignation("");
                      setAlreadyIssued("");
                      setIssueDays("");
                      setAccordionExpanded(false);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Receiver Member" />
                  )}
                />
              </Grid>


              <Grid item lg={4} xs={12}>
                <TextField
                  label="File Name"
                  placeholder="File Name"
                  size="small"
                  fullWidth
                  value={epcNumber}
                  InputLabelProps={{ shrink: true }}

                />
              </Grid>

            </Grid>

            <Grid xs={12} sm={12} item style={{ marginBottom: "10px" }}>
              <Accordion expanded={accordionExpanded}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                  sx={{ backgroundColor: "#f5f5f5", color: "#1c1124" }}
                >
                  <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
                    Member Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    item
                    xs={12}
                    container
                    spacing={2}
                    sx={{ marginTop: "5px" }}
                  >
                    {memberName && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          // value={formik.values.applicationFees}
                          // id="applicationFees"
                          // name="applicationFees"
                          type="text"
                          label="Employee Name"
                          placeholder="Employee Name"
                          size="small"
                          value={memberName}
                          //  value={memberOption?.empName}
                          //  value={selectedMember?.value?.empName}
                          fullWidth
                          style={{ backgroundColor: "white" }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}

                    {department && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="Department"
                          placeholder="Department"
                          size="small"
                          value={department}
                          // value={memberDetail?.empCode}
                          fullWidth
                          style={{ backgroundColor: "white" }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}

                    {memberGroup && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label=" Mobile No"
                          placeholder=" Mobile No"
                          size="small"
                          fullWidth
                          value={memberGroup}
                          // value={memberDetail?.empMobileNo}
                          style={{ backgroundColor: "white" }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}

                    {issuesLimit && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="Pan No"
                          placeholder="Pan No"
                          size="small"
                          fullWidth
                          value={issuesLimit}
                          style={{ backgroundColor: "white" }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}

                    {courseDesignation && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label=" D. O. B."
                          placeholder=" D. O. B."
                          size="small"
                          fullWidth
                          value={courseDesignation}
                          // value={memberDetail?.empDob}
                          style={{ backgroundColor: "white" }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}

                    {alreadyIssued && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="Email"
                          placeholder="Email"
                          size="small"
                          fullWidth
                          value={alreadyIssued}
                          // value={memberDetail?.email}
                          style={{ backgroundColor: "white" }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}

                    {issueDays && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="Designation Name"
                          placeholder="Designation Name"
                          size="small"
                          fullWidth
                          value={issueDays}
                          // value={memberDetail?.departmentName}
                          style={{ backgroundColor: "white" }}
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>
              <br />
            </Grid>

            {/* File Details */}
            {/*  Member Details */}
            <Grid xs={12} sm={12} item style={{ marginBottom: "10px" }}>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                  sx={{ backgroundColor: "#f5f5f5", color: "#1c1124" }}
                >
                  <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
                    File Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    item
                    xs={12}
                    container
                    spacing={2}
                    sx={{ marginTop: "5px" }}
                  >
                    <Grid xs={12} sm={4} item style={{ marginBottom: "10px" }}>
                      <Autocomplete
                        disablePortal
                        options={fileDetails}
                        getOptionLabel={(option: any) => option.fileName}
                        fullWidth
                        size="small"
                        onChange={(event, newValue: any) => {
                          if (newValue) {
                            console.log("Selected value:", newValue);
                            setFileID(newValue?.value);
                            setChakNo(newValue?.chackNo);
                            setFileName(newValue?.fileName);
                            setFileNo(newValue?.fileNo);
                            setRemark(newValue?.remark);
                            setRFID(newValue?.rfid);
                            setSynopsis(newValue?.currentLocation);
                            setTotalPages(newValue?.totalPages);
                            console.log("Selected value syno:", synopsis);

                          } else {
                            setChakNo("");
                            setFileName("");
                            setFileNo("");
                            setRemark("");
                            setRFID("");
                            setSynopsis("");
                            setTotalPages("");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select File Detail" />
                        )}
                      />
                    </Grid>

                    {chakno && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="Chak No."
                          placeholder="Chak No."
                          size="small"
                          fullWidth
                          value={chakno}
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                    )}

                    {fileNo && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="File No."
                          placeholder="File No."
                          size="small"
                          fullWidth
                          value={fileNo}
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                    )}

                    {remark && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="Remark"
                          placeholder="Remark"
                          size="small"
                          value={remark}
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                    )}

                    {rfid && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <TextField
                          type="text"
                          label="RFID"
                          placeholder="RFID"
                          value={rfid}
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                    )}

                    {synopsis && (
                      <Grid
                        xs={12}
                        sm={4}
                        item
                        style={{ marginBottom: "10px" }}
                      >
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={LocationOption}
                          value={
                            LocationOption.find(
                              (option: any) => option.value === parseInt(synopsis)) || null
                          }
                        //  value={defaultLocation || null}
                          // onChange={handleLocationChange}
                          fullWidth
                          size="small"
                          onFocus={(event) => event.target.blur()}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="From Location"
                              InputProps={{
                                ...params.InputProps,
                                readOnly: true
                              }}
                            />
                          )}
                        />
                      </Grid>
                    )}


                    <Grid
                      xs={12}
                      sm={4}
                      item
                      style={{ marginBottom: "10px" }}
                    >
                      <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={LocationOption}
                        fullWidth
                        size="small"
                        onChange={(event, newValue: any) => {
                          console.log(newValue?.label);
                          setTotalPages(newValue?.label);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="To Location"
                            InputProps={{
                              ...params.InputProps,
                              readOnly: true
                            }}
                          />
                        )}
                      />
                    </Grid>




                    <Grid item xs={2}>
                      <Button
                        fullWidth
                        style={{
                          backgroundColor: "#059669",
                          color: "white",
                          marginBottom: "10px",
                        }}
                        onClick={addRow}
                      >
                        Add
                      </Button>
                    </Grid>

                    <Grid container xs={12} spacing={2}>
                      <Grid xs={12} sm={12} item>
                        <Table
                          style={{
                            borderCollapse: "collapse",
                            width: "100%",
                            border: "1px solid black",
                            marginLeft: "20px",
                          }}
                        >
                          <thead
                            style={{
                              backgroundColor: "#2196f3",
                              color: "#f5f5f5",
                            }}
                          >
                            <tr>
                              {/* <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingBlock: "10",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                Action
                              </th> */}

                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingBlock: "10",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                File Name
                              </th>

                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                File No
                              </th>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                Chak No
                              </th>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                RFID
                              </th>

                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                From Location
                              </th>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                To Location
                              </th>
                              <th
                                style={{
                                  borderLeft: "1px solid black",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                Remark
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ border: "1px solid black" }}>
                            {fileDetailsTableData.map(
                              (row: any, index: any) => (
                                <tr
                                  key={row.id}
                                  style={{ border: "1px solid black" }}
                                >
                                  {/* <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    <input type="checkbox"
                                      onChange={handleChange}
                                    />
                                  </td> */}
                                  <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row.isEditing ? (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        type="text"
                                        value={row.fileName}
                                      // onChange={(e) =>
                                      //   handleInputChange(
                                      //     row.id,
                                      //     "effectiveDate",
                                      //     e.target.value
                                      //   )
                                      // }
                                      />
                                    ) : (
                                      row.fileName
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row.isEditing ? (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        type="text"
                                        value={row.fileNo}
                                      // onChange={(e) =>
                                      //   handleInputChange(
                                      //     row.id,
                                      //     "rate",
                                      //     e.target.value
                                      //   )
                                      // }
                                      />
                                    ) : (
                                      row.fileNo
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row.isEditing ? (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        type="text"
                                        value={row.chakno}
                                      // onChange={(e) =>
                                      //   handleInputChange(
                                      //     row.id,
                                      //     "rate",
                                      //     e.target.value
                                      //   )
                                      // }
                                      />
                                    ) : (
                                      row.chakno
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row.isEditing ? (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        type="text"
                                        value={row.rfid}
                                      // onChange={(e) =>
                                      //   handleInputChange(
                                      //     row.id,
                                      //     "rate",
                                      //     e.target.value
                                      //   )
                                      // }
                                      />
                                    ) : (
                                      row.rfid
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row.isEditing ? (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        type="text"
                                        value={row.synopsis}
                                      />
                                    ) : (
                                      row.synopsis
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row.isEditing ? (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        type="text"
                                        value={row.totalPages}
                                      // onChange={(e) =>
                                      //   handleInputChange(
                                      //     row.id,
                                      //     "rate",
                                      //     e.target.value
                                      //   )
                                      // }
                                      />
                                    ) : (
                                      row.totalPages
                                    )}
                                  </td>

                                  <td
                                    style={{
                                      borderLeft: "1px solid black",
                                      borderTop: "1px solid black",
                                      textAlign: "center",
                                    }}
                                  >
                                    {row.isEditing ? (
                                      <TextField
                                        size="small"
                                        fullWidth
                                        type="text"
                                        value={row.remark}
                                      // onChange={(e) =>
                                      //   handleInputChange(
                                      //     row.id,
                                      //     "rate",
                                      //     e.target.value
                                      //   )
                                      // }
                                      />
                                    ) : (
                                      row.remark
                                    )}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </Grid>
                    </Grid>
                     
                      <Grid container item xs={12} alignItems="end" justifyContent="flex-end">
                      <Button
                        // fullWidth
                        style={{
                          backgroundColor: "#4990E2",
                          color: "white",
                          marginBottom: "10px",
                          marginRight:"10px"
                        }}
                        onClick={(e)=>handleSubmit()}
                      >
                        Save
                      </Button>
                      <Button
                        // fullWidth
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          marginBottom: "10px",
                        }}
                        
                      >
                        Reset
                      </Button>
                    </Grid>

                  </Grid>
                </AccordionDetails>
              </Accordion>
              <br />
            </Grid>
          </Grid>
        </form>
      </CardContent>
    </div>
  );
};

export default IssueReturn;
